import "../styles/AdminInterface.css"
/* import "../styles/App.css"
 */import React, { useState, useEffect } from 'react'
import BackendAPI from "../API/BackendAPI"
import IconButton from '@mui/material/IconButton';

import { useHistory } from 'react-router-dom';
import { TextField, FormControl, InputLabel, Button,Tooltip , Divider, Typography, TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, Select, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core"
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';

import Popup from "../components/Popup"
import Sidebar from "../components/Sidebar"
import cookie from 'react-cookies'


const AdminStatistiquesJeux = () => {
  // console.log("admin")
  const history = useHistory()


  const user = cookie.load("user")
  // console.log(user)
  const handleDisconnect = () => {
    // console.log("handleDisconnect")
    cookie.save('user', "disconnected", {
      path: '/',
      maxAge: 60 * 60 * 1.5, //sec
    })
    history.push('/login');
  }


  if (user === null || user === undefined || user == "disconnected") history.push("/login");
  if (user !== null && user !== undefined && user.username !== undefined && !user.username.toUpperCase().includes("ADMIN")) handleDisconnect()


  // const [actualiser,setActualiser]=useState(true)

  const [popupText, setPopupText] = useState(null)

  const [users, setUsers] = useState(null)
  const [localUsers, setLocalUsers] = useState(users);
  const [popupUser, setPopupUser] = useState(null)
  const [newUser, setNewUser] = useState(null)
  const [userList,setUserList] = useState([])
  const [localUserList, setLocalUserList] = useState([])

  const liste_jeux = ["Tous","Compta 1 - Attaque des cupcakes", "Compta 2 - Quiz en folie", "Compta 3 - Panique au PCG","Compta 4 - Balance ton écriture","Compta 5 - Belle brioche",
    "Compta 6 - NOUVEAU JEU","SI 1 - Datman","SI 2 - Casse-tête ERP","SI 3 - Train de processus","SI 4 - Datacrush","SI 5 - Quiz en folie"]
  
  const [annee, setAnnee] = useState("2025-2026")
  const [numJeu, setNumJeu] = useState("Tous")
  const [groupes,setGroupes]=useState([])
  const [nom, setNom] = useState('Tous');
  const [prenom, setPrenom] = useState('Tous');
  const [pseudo, setPseudo] = useState('Tous');
  const [campus, setCampus] = useState('Tous');
  const [programme, setProgramme] = useState('Tous')
  const [groupe, setGroupe] = useState('Tous');

  // Données exemple pour les options des filtres
  const [anneesOptions,setAnneesOptions] = useState(["2023-2024","2024-2025","2025-2026","2026-2027","2027-2028"])

  const [nomOptions,setNomOptions] = useState([])
  const [prenomOptions,setPrenomOptions] = useState([])
  const [jeuxOptions,setJeuxOptions] = useState([])
  
  const [pseudosOptions,setPseudosOptions] = useState([])
  const [campusOptions,setCampusOptions] = useState([])
  const [programmeOptions,setProgrammeOptions] = useState([])
  const [groupesOptions,setGroupesOptions] = useState([])

  const handleFilterChange = (setter) => (event) => {
    setter(event.target.value);
  };

  useEffect(() => {
    const getStatistiqueJeux = async () => {

      const response = await BackendAPI.getStatistiqueJeux()
      // console.log(response)
      setUserList(response);
    
      const groupes = await BackendAPI.getGroupes()
          setGroupes(groupes)
      
    };

    getStatistiqueJeux();
  }, []);


  const getUniqueValues = (data, attribute,campus, programme, groupe) => {

    if(data==null ) return []

    const filtered_data = data
        .filter((val)=>val.campus==campus || campus == "Tous" || attribute=="campus")
        .filter((val)=>val.programme==programme || programme == "Tous" || attribute=="campus" || attribute=="programme")
        .filter((val)=>val.groupe==groupe || groupe == "Tous" || attribute=="campus"  || attribute=="programme" || attribute=="groupe")

    const values = filtered_data?.map(item => {
      if (attribute === "numJeu") {
        return item[attribute] - 10; // Si l'attribut est 'numJeu', soustraire 10
      }
      return item[attribute]; // Sinon, retourner la valeur normale de l'attribut
    });
  
    const uniqueValues = [...new Set(values)].filter((val)=>val!="").sort(); 
    uniqueValues.unshift("Tous"); 
    return uniqueValues;
  };

  useEffect(() => {
    if (userList !== null && userList.length>0) {
      setNomOptions(getUniqueValues(userList,"nom"))
      setPrenomOptions(getUniqueValues(userList,"prenom"))
      setJeuxOptions(liste_jeux)
      setPseudosOptions(getUniqueValues(userList,"pseudo"))
      // setCampusOptions(getUniqueValues(userList,"campus"))
      // setGroupesOptions(getUniqueValues(userList,"groupe"))
      filterAndGroupList(userList)
    }
  }, [userList])


  useEffect(()=>{
        if (groupes !== null && groupes.length>0) {
          setCampusOptions(getUniqueValues(groupes,"campus",campus, programme, groupe))
          setProgrammeOptions(getUniqueValues(groupes,"programme",campus, programme, groupe))
          setGroupesOptions(getUniqueValues(groupes,"groupe",campus, programme, groupe))
        }
        
      },[groupes,campus,programme])
    
      useEffect(()=>{
        if( groupes.filter((val)=> val.programme== programme && val.campus==campus).length==0){
          setProgramme("Tous")
        }
    
         if( groupes.filter((val)=> val.programme== programme && val.campus==campus && val.groupe == groupe).length==0){
          setGroupe("Tous")
        }
        
      },[campus])
    
      useEffect(()=>{   
        if( groupes.filter((val)=>val.groupe== groupe && val.programme== programme && val.campus == campus).length==0){
          setGroupe("Tous")
        }
      },[programme])
    
      useEffect(()=>{
        if(groupe!="Tous"){
          setProgramme(groupes.filter((val)=>val.groupe== groupe)[0].programme)
          setCampus(groupes.filter((val)=>val.groupe== groupe)[0].campus)
        }
      },[groupe])


  const filterAndGroupList=(userList)=>{
var jeu = "Tous"
    switch (numJeu) {
      case "Compta 1 - Attaque des cupcakes":
        jeu="11"
        break;
      case "Compta 2 - Quiz en folie":
        jeu="12"
        break;
      case "Compta 3 - Panique au PCG":
        jeu="13"
        break;
      case "Compta 4 - Balance ton écriture":
        jeu="14"
        break;
      case "Compta 5 - Belle brioche":
        jeu="15"
        break;
      case "Compta 6 - NOUVEAU JEU":
        jeu="16"
        break;
      case "SI 1 - Datman":
        jeu="21"
        break;
      case "SI 2 - Casse-tête ERP":
        jeu="22"
        break;
      case "SI 3 - Train de processus":
        jeu="23"
        break;
      case "SI 4 - Datacrush":
        jeu="24"
        break;
      case "SI 5 - Quiz en folie":
        jeu="25"
        break;

      default:
        break;
    }
    

    function isDateInRange(dateStr) {
    const inputDate = parseYMD(dateStr);
    // console.log(inputDate)
    // console.log(dateStr)
    if (!inputDate) return false;

    // EXEMPLE : année académique du 15/09/<year> au 14/09/<year+1>
    // attention : monthIndex 8 = septembre (0-indexé)
    const yearInt = parseInt(annee.split("-")[0], 10);
    const startDate = new Date(yearInt, 8, 15); // 15 sept de yearInt
    const endDate = new Date(yearInt + 1, 8, 14); // 14 sept de yearInt+1

    return inputDate >= startDate && inputDate <= endDate;
  }

    function parseYMD(dateStr) {
  if (!dateStr) return null;
  const m = dateStr.match(/^(\d{4})-(\d{2})(?:-(\d{2}))?/);
  if (m) {
    const y = parseInt(m[1], 10);
    const mm = parseInt(m[2], 10) - 1; // monthIndex
    const dd = m[3] ? parseInt(m[3], 10) : 1; // si pas de jour, on met 1
    return new Date(y, mm, dd); // évite les problèmes de timezone avec "YYYY-MM-DD"
  }
  // fallback : essaie le constructeur Date (ex: ISO complet)
  const d = new Date(dateStr);
  return isNaN(d) ? null : d;
}

  function latestDateString(aStr, bStr) {
    const a = parseYMD(aStr);
    const b = parseYMD(bStr);
    if (!a && !b) return null;
    if (!a) return bStr;
    if (!b) return aStr;
    return a >= b ? aStr : bStr;
  }
    const groupedByUser = userList
      .filter((user) => (jeu && jeu!="Tous" ? user.numJeu==jeu : true))
      .filter((user) => (annee && annee!="Tous" ? isDateInRange(user.dernierePartie): true))
      .filter((user) => (nom && nom!="Tous" ? user.nom==nom: true))
      .filter((user) => (prenom && prenom!="Tous" ? user.prenom==prenom: true))
      .filter((user) => (pseudo && pseudo!="Tous" ? user.pseudo==pseudo: true))
      .filter((user) => (campus && campus!="Tous" ? user.campus==campus: true))
      .filter((user) => (programme && programme!="Tous" ? user.programme==programme: true))
      .filter((user) => (groupe && groupe!="Tous" ? user.groupe==groupe: true))
      
      .reduce((acc, curr) => {
        
        const { idUser } = curr;
        // récupère les champs numériques en assurant un fallback
        const nbParties = Number(curr.nbParties || 1);
        const tempsJeu = Number(curr.tempsJeu || 0);
        const dp = curr.dernierePartie || null; // string yyyy-mm-dd attendu

        if (!acc[idUser]) {
          // clone l'objet courant et initialise les compteurs
          acc[idUser] = { ...curr };
          acc[idUser].nbParties = nbParties;
          acc[idUser].tempsJeu = tempsJeu;
          acc[idUser].dernierePartie = dp;
        } else {
          // accumulation
          acc[idUser].nbParties += nbParties;
          acc[idUser].tempsJeu += tempsJeu;
          // garde la date la plus récente (compare en Date)
          acc[idUser].dernierePartie = latestDateString(acc[idUser].dernierePartie, dp);
        }
  
      return acc;
    }, {});
  
    setLocalUserList( Object.values(groupedByUser));
    return Object.values(groupedByUser)
  }

  useEffect(()=>{
    
    const localUserList=filterAndGroupList(userList)
   setJeuxOptions(liste_jeux)
if (nom=="Tous"){

      if(groupe=="Tous"){
        
        if(campus=="Tous"){
          
          
          if(pseudo=="Tous"){
            setPrenomOptions(getUniqueValues(userList,"prenom"))
            setNomOptions(getUniqueValues(userList,"nom"))
            setPseudosOptions(getUniqueValues(userList,"pseudo"))
            // setCampusOptions(getUniqueValues(userList,"campus"))
            // setGroupesOptions(getUniqueValues(userList,"groupe"))
          }else{
            setPrenomOptions(getUniqueValues(localUserList,"prenom"))
            setNomOptions(getUniqueValues(localUserList,"nom"))
            setPseudosOptions(getUniqueValues(localUserList,"pseudo"))
            // setCampusOptions(getUniqueValues(localUserList,"campus"))
            // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
          }

        }else{
          setPrenomOptions(getUniqueValues(localUserList,"prenom"))
          setNomOptions(getUniqueValues(localUserList,"nom"))
          setPseudosOptions(getUniqueValues(localUserList,"pseudo"))
          // setCampusOptions(getUniqueValues(localUserList,"campus"))
          // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
        }


      }else{
        setPrenomOptions(getUniqueValues(localUserList,"prenom"))
        setNomOptions(getUniqueValues(localUserList,"nom"))
        setPseudosOptions(getUniqueValues(localUserList,"pseudo"))
        // setCampusOptions(getUniqueValues(localUserList,"campus"))
        // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
      }

    }else{
      setPrenomOptions(getUniqueValues(localUserList,"prenom"))
      setNomOptions(getUniqueValues(localUserList,"nom"))
      setPseudosOptions(getUniqueValues(localUserList,"pseudo"))
      // setCampusOptions(getUniqueValues(localUserList,"campus"))
      // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
    }
    
  },[annee,numJeu,nom,prenom,pseudo,campus,programme,groupe])

const formatDate = (dateString) => {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
};

const formatSeconds = (seconds) => {
  const hours = Math.floor(seconds / 3600); // nombre d'heures
  const minutes = Math.floor((seconds % 3600) / 60); // nombre de minutes
  return `${String(hours).padStart(2, "0")}h${String(minutes).padStart(2, "0")}`;
}

const renderStatistiqueApp = () => {
  if (userList !== null && userList.length > 0) {
    return (
      <TableContainer component={Paper} style={{ maxHeight: "100%" }} >
        <Table stickyHeader aria-label="customized table">
          <TableHead>
            <TableRow key={"HEAD"}>
              {/* <TableCell align="center" style={{ width: 80 }}>Rang</TableCell> */}
              <TableCell align="center" style={{ width: 150 }}>Nom</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Prénom</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Pseudo</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Campus</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Programme</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Groupe</TableCell>
              <TableCell align="center" style={{ width: 200 }}>Nombre parties</TableCell>
              <TableCell align="center" style={{ width: 200 }}>Temps jeu</TableCell>
              <TableCell align="center" style={{ width: 200 }}>Dernière partie</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {localUserList
              .map((u, index) => (
                <TableRow key={u.id} style={{ height: 40 }}>
                  <TableCell align="center">{u.nom}</TableCell>
                  <TableCell align="center">{u.prenom}</TableCell>
                  <TableCell align="center">{u.pseudo}</TableCell>
                  <TableCell align="center">{u.campus}</TableCell>
                  <TableCell align="center">{u.programme}</TableCell>
                  <TableCell align="center">{u.groupe}</TableCell>
                  <TableCell align="center">{u.nbParties}</TableCell>
                  <TableCell align="center">{formatSeconds(u.tempsJeu)}</TableCell>
                  <TableCell align="center">{formatDate(u.dernierePartie)}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
};


const exportToCSV = () => {
  if (!localUserList || localUserList.length === 0) {
    alert("Aucun utilisateur à exporter !");
    return;
  }

  // Définition des colonnes CSV
  const headers = ["Nom", "Prénom", "Pseudo","Email",  "Campus","Programme", "Groupe","Nombre de parties","Temps de jeu","Date dernière partie"];

  // Génération des lignes
  const rows = localUserList
  .sort((a, b) => b.nbParties - a.nbParties) // tri décroissant par score
  .map((u, index) => [
    u.nom,
    u.prenom,
    u.pseudo,
    u.email,
    u.campus,
    u.programme,
    u.groupe,
    u.nbParties,
    formatSeconds(u.tempsJeu),
    u.dernierePartie
  ]);

  // Transformation en texte CSV
  const csvContent = [
    headers.join(";"), // séparateur ;
    ...rows.map(row => row.join(";"))
  ].join("\n");

  // Création du fichier Blob
  // const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
  // Création d'un lien de téléchargement temporaire
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);

  if(numJeu=="Tous"){
    link.setAttribute("download", "Statistiques générales.csv");
  }else{
    link.setAttribute("download", "Statistiques "+numJeu+".csv");
  }

  // link.setAttribute("download", "Statistiques jeux.csv");
  
  

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  const extractStats = (u) => {
    const data = userList.filter((val) => val.idUser === u.idUser); // Corrigez l'opérateur d'affectation `=` par `===`
    const gameStats = {};
  
    // // Parcours de chaque entrée dans les données
    // data.forEach(entry => {
    //   // Vérifie si le score est valide et supérieur à 0
    //   if (entry.bestScore > 0) {
    //     // Enregistre le score associé au numéro de jeu
    //     gameScores[`Jeu ${entry.numJeu-10}`] = entry.bestScore; 
    //   }
    // });
  
    // // Transforme les résultats en tableau formaté avec des balises HTML pour les sauts de ligne
    // return Object.entries(gameScores)
    // .sort(([gameA], [gameB]) => {
    //   // Extrait le numéro du jeu pour effectuer un tri numérique
    //   const numA = parseInt(gameA.replace('Jeu ', ''), 10);
    //   const numB = parseInt(gameB.replace('Jeu ', ''), 10);
    //   return numA - numB;
    // })
    // .map(([game, score]) => `${game} : ${score} pts`)
    // .join('<br>'); // Utilisation de <br> pour le rendu HTML
  };
  

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div
        className="body-admin"
      >
        <Typography variant="h1" color="primary">Statistiques Jeux</Typography>
        <Divider />
        {/* {
        popupText!=null ?
        <Popup open={true} text={popupText} reponse={"Supprimer Utilisateur"} handleClose={handleClosePopup} ></Popup>
        :
        null
      } */}
        <div style={{ margin: 10 }}  >
          <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
            <FormControl size="small" variant="outlined">
              <InputLabel>Année</InputLabel>
              <Select
                value={annee}
                variant="outlined"
                onChange={handleFilterChange(setAnnee) }
              >
                {anneesOptions.map(c => (
                  <MenuItem key={c} value={c} style={{ paddingTop: 8, paddingBottom: 8 }}>{c}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" variant="outlined">
              <InputLabel>Jeu</InputLabel>
              <Select
                value={numJeu}
                variant="outlined"
                onChange={handleFilterChange(setNumJeu) }
              >
                {jeuxOptions.map(c => (
                  <MenuItem key={c} value={c} style={{ paddingTop: 8, paddingBottom: 8 }}>{c}</MenuItem>
                ))}
              </Select>
            </FormControl>
            
            <FormControl size="small" variant="outlined">
            <InputLabel>Nom</InputLabel>
              <Select
                value={nom}
                onChange={handleFilterChange(setNom)}
                label="Nom"
              >
                      {nomOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" variant="outlined">
              <InputLabel>Prénom</InputLabel>
              <Select
                value={prenom}
                onChange={handleFilterChange(setPrenom)}
                label="Prénom"
              >
                      {prenomOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Pseudo */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Pseudo</InputLabel>
              <Select
                value={pseudo}
                onChange={handleFilterChange(setPseudo)}
                label="Pseudo"
              >

                {pseudosOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Campus */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Campus</InputLabel>
              <Select
                value={campus}
                onChange={handleFilterChange(setCampus)}
                label="Campus"
              >

                {campusOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" variant="outlined">
              <InputLabel>Programme</InputLabel>
              <Select
                value={programme}
                onChange={handleFilterChange(setProgramme)}
                label="Programme"
              >

                {programmeOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Groupe */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Groupe</InputLabel>
              <Select
                value={groupe}
                onChange={handleFilterChange(setGroupe)}
                label="Groupe"
              >

                {groupesOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <IconButton aria-label="download" style={{padding:10}} onClick={exportToCSV}>
              <DownloadIcon  />
            </IconButton>
          </div>
          <br></br>
          {renderStatistiqueApp()}

          {/*   <br></br>
          <Typography variant="h5" color="primary">Créer un nouvel étudiant</Typography>

          {renderNewUser()} */}
          {/* {newUser.nom} {newUser.prenom} {newUser.email} ({newUser.campus} - {newUser.groupe}) */}
        </div>



        {/* </div> */}

      </div></div>
  );
}

export default AdminStatistiquesJeux;

